import TableContainer from 'components/TableContainer';
import React, { useCallback } from 'react';
import { Sorters } from 'utils/tableUtils';
import { ToggleButton } from '../IntegrationsTable';
import _ from 'lodash';
import ActionMenuV2 from 'components/ActionMenuV2';
import { PermissionSetMap } from 'constants/RBACConstants';
import ModalUtil from 'utils/modalUtil';
import AlertConfigFormPopup from './AlertConfigFormPopup';
import ToolsIntegrationsAPI from 'restAPI/ToolsIntegrationAPI';
import AuthorisedContainer from 'components/AuthorisedContainer';
import { Button } from 'antd';

const actions = [{
	type: "edit",
	permission: PermissionSetMap.EDIT_TOOL_CONFIG,
}, {
	type: "delete",
	permission: PermissionSetMap.DELETE_TOOL,
}]

export default function AlertConnectListing({ data, onUpdateConfigComponent = _.noop, enabledAPI, loading }) {

	const onDelete = useCallback((id) => {
		return ToolsIntegrationsAPI.deleteAlertIntegration(id).promise.then(() => onUpdateConfigComponent());
	}, [onUpdateConfigComponent]);

	const onActionClick = useCallback(async (e, { name, data }) => {
		switch (name) {
			case "edit":
				ModalUtil.show({
					content: <AlertConfigFormPopup data={data} />,
					afterClose: (success) => success && onUpdateConfigComponent()
				})
				break;
			case "delete":
				await onDelete(data.id);
				break;
			default:
				break;
		}
	}, [onUpdateConfigComponent, onDelete]);

	const showForm = useCallback(()=>{
		ModalUtil.show({
			content: <AlertConfigFormPopup data={data} />,
			afterClose: (data) => data && onUpdateConfigComponent()
		})
	}, [data, onUpdateConfigComponent])

	const customAddButton = <AuthorisedContainer permission={PermissionSetMap.WRITE_TOOLS} placement={"left"}>
		<Button
		size="small" 
		type="primary"
		onClick={showForm}
		disabled={!_.isEmpty(data)}>
			Add
		</Button>
	</AuthorisedContainer>

	const columns = [{
		title: "Name",
		dataIndex: "name",
		key: "name",
		sorter: Sorters.STRING("name")
	}, {
		title: "URL",
		dataIndex: "url",
		key: "url",
		sorter: Sorters.STRING("url")
	}, {
		title: "Config",
		dataIndex: "enabled",
		key: "enabled",
		sorter: Sorters.STRING("enabled"),
		render: (enabled, record) => {
			return <ToggleButton text={enabled} record={record} integrationData={{ enabledAPI }} onUpdateConfigComponent={onUpdateConfigComponent} />
		}
	}, {
		title: "Action",
		dataIndex: "id",
		width: 70,
		render: (id, record) => {
			return (
				<ActionMenuV2 items={actions} onClick={onActionClick} data={record} />
			)
		}
	}]
	return (
		<TableContainer
			columns={columns}
			dataSource={data}
			loading={loading}
			extras={customAddButton}
		/>
	)
}
